module.exports = __webpack_public_path__ + "img/goods3.28f6ba42.jpg";